import fields from "./fields.utils.js";
import moment from "moment";

const schema_energy = {
  ...fields.notes,
  //source
  source_uuid: {
    type: "select",
    label: "source",
    value: "",
    options: [],
    required: true,
  },
  first_name: {
    label: "First Name",
    placeholder: "First Name",
    type: "text",
    value: "",
    required: true,
  },
  last_name: {
    label: "Last Name",
    placeholder: "Last Name",
    type: "text",
    value: "",
    required: true,
  },
  postcode: {
    label: "Postal Code",
    placeholder: "Postal Code",
    type: "address-lookup",
    value: "",
    required: true,
  },
  address1: {
    label: "Address Line 1",
    placeholder: "Address Line 1",
    value: "",
    type: "text",
    required: true,
  },
  address2: {
    label: "Address Line 2",
    placeholder: "Address Line 2",
    value: "",
    type: "text",
  },
  address3: {
    label: "Address Line 3",
    placeholder: "Address Line 3",
    type: "text",
    value: "",
  },
  address4: {
    label: "Address Line 4",
    placeholder: "Address Line 4",
    type: "text",
    value: "",
  },
  city: {
    label: "City",
    placeholder: "City",
    type: "text",
    value: "",
    required: true,
  },
  telephone: {
    label: "Telephone",
    placeholder: "Telephone",
    type: "text",
    value: "",
    required: true,
  },
  email: {
    label: "Email Address",
    placeholder: "Email Address",
    type: "email",
    value: "",
  },
  energy_type: {
    label: "Energy type",
    type: "radio",
    value: "",
    required: true,
  },
  electricity_supplier: {
    label: "Who is your current electricity supplier?",
    type: "radio",
    value: "",
    required: true,
  },
  gas_supplier: {
    label: "Who is your current gas supplier?",
    type: "radio",
    value: "",
    required: true,
  },
  business_type: {
    label: "What is your business type?",
    type: "select",
    value: "",
    required: true,
  },
  business_name: {
    label: "What is the name of your business?",
    type: "search-auto-suggest",
    value: "",
    options: [],
    required: true,
  },
  contract_start_date: {
    label: "contract start date",
    type: "date-drop-down",
    value: "",
    required: true,
    minYear: moment().subtract(5, 'years').format('YYYY'),
    dateOrder: ['month', 'year']
  },
  contract_term: {
    label: "Remaining Contract Term",
    type: "select",
    value: "",
    options: [],
    orderOptions: false,
    required: true
  },
  ...fields.energy_usage,
  ...fields.marketing,
  ...fields.cross_selling,
};
export default schema_energy;
